// extracted by mini-css-extract-plugin
export default {"disableLink":"wj-z"};